import { createReducer, on } from '@ngrx/store';

import { SetRelatedsCarouselsForPlaceSuccess, SetRelatedsCarouselsProductsIdsSuccess, LoadRelatedCarouselProductsSuccess, SetRelatedProductViewed, LoadRelatedCarouselProducts } from './related-products.actions';
import { RelatedProductsState, relatedProductsInitialState } from './related-products.state';

export const relatedProductsReducer = createReducer(
    relatedProductsInitialState,

    on(SetRelatedsCarouselsForPlaceSuccess, (state: RelatedProductsState, { placeName, relatedPlace, baseProducts }) => {
        return {
            ...state,
            places: {
                ...state.places,
                [placeName]: { ...relatedPlace, baseProducts },
            },
        };
    }),
    on(SetRelatedsCarouselsProductsIdsSuccess, (state: RelatedProductsState, {
        placeName, carousels, excludedProducts,
    }) => {
        return {
            ...state,
            places: {
                ...state.places,
                [placeName]: {
                    ...state.places[placeName],
                    carousels: { ...carousels || {} },
                    excludedProducts,
                },
            },
        };
    }),
    on(LoadRelatedCarouselProducts, (state: RelatedProductsState, {
        placeName, carousel,
    }) => {
        return {
            ...state,
            places: {
                ...state.places,
                [placeName]: {
                    ...state.places[placeName],
                    carousels: {
                        ...state.places[placeName].carousels,
                        [carousel.id]: {
                            ...state.places[placeName].carousels?.[carousel.id],
                            isLoadingProducts: true,
                        },
                    },
                },
            },
        };
    }),
    on(LoadRelatedCarouselProductsSuccess, (state: RelatedProductsState, {
        placeName, carousel, page, productsMap, filteredItemsIds,
    }) => {
        return {
            ...state,
            places: {
                ...state.places,
                [placeName]: {
                    ...state.places[placeName],
                    carousels: {
                        ...state.places[placeName].carousels,
                        [carousel.id]: {
                            ...state.places[placeName].carousels?.[carousel.id],
                            currentPage: page,
                            productsLoaded: {
                                ...state.places[placeName].carousels?.[carousel.id]?.productsLoaded,
                                ...productsMap,
                            },
                            filteredItemsIds: [
                                ...filteredItemsIds
                                // biome-ignore lint/correctness/noUnsafeOptionalChaining: <explanation>
                                || state.places[placeName].carousels?.[carousel.id]?.filteredItemsIds,
                            ],
                            isLoadingProducts: false,
                        },
                    },
                },
            },
        };
    }),
    on(SetRelatedProductViewed, (state: RelatedProductsState, { placeName, carousel }) => {
        return {
            ...state,
            places: {
                ...state.places,
                [placeName]: {
                    ...state.places[placeName],
                    carousels: {
                        ...state.places[placeName].carousels,
                        [carousel.id]: {
                            ...state.places[placeName].carousels?.[carousel.id],
                            productsViewed: state.places[placeName].carousels?.[carousel.id]?.productsViewed + 1,
                        },
                    },
                },
            },
        };
    })
);
